import { render, staticRenderFns } from "./AuthorityDialog.vue?vue&type=template&id=305fb492&scoped=true"
import script from "./AuthorityDialog.vue?vue&type=script&lang=js"
export * from "./AuthorityDialog.vue?vue&type=script&lang=js"
import style0 from "./AuthorityDialog.vue?vue&type=style&index=0&id=305fb492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305fb492",
  null
  
)

export default component.exports